import { AdditionalInfoDialogBoxComponent } from './components/additional-info-dialog-box/additional-info-dialog-box.component';
import { TranslationService } from './services/translation.service';
import { RootComponent } from './components/root/root.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { VehicleInfoComponent } from './components/vehicle-info/vehicle-info.component';
import { MaintenancePlanComponent } from './components/maintenance-plan/maintenance-plan.component';
import { ServiceHistoryComponent } from './components/service-history/service-history.component';

import { TranslatePipe } from './pipes/translate.pipe';
import { NgxSpinnerModule } from "ngx-spinner";

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './material.module';
import { FormsModule } from '@angular/forms';
import { AppConfig } from './app.config';
import { environment } from 'src/environments/environment';
import { SetTokenInterceptorService } from './services/setTokenIntercepter.service';
import { DatePipe } from './pipes/date.pipe';
import { YearFormatterPipe } from './pipes/yearformatter.pipe';
import { DateMonthFormatterPipe } from './pipes/datemonthformatter.pipe';
import { VehicleInfoService } from './services/vehicle-info.service';
import { VehicleInfoDialogComponent } from './components/vehicle-info-dialog/vehicle-info-dialog.component';
import { ServiceHistoryEditComponent } from './components/service-history-edit/service-history-edit.component';
import { ServiceHistoryEditDialogComponent } from './components/service-history-edit-dialog/service-history-edit-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CustomLoader } from './utils/CustomLoader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);
}
@NgModule({
  declarations: [
    RootComponent,
    VehicleInfoComponent,
    MaintenancePlanComponent,
    ServiceHistoryComponent,
    TranslatePipe,
    DatePipe,
    YearFormatterPipe,
    DateMonthFormatterPipe,
    AdditionalInfoDialogBoxComponent,
    VehicleInfoDialogComponent,
    ServiceHistoryEditComponent,
    ServiceHistoryEditDialogComponent

  ],
  entryComponents: [
    AdditionalInfoDialogBoxComponent,
    VehicleInfoDialogComponent,
    ServiceHistoryEditDialogComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    ScrollingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        //useClass: CustomLoader,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    TranslationService,
    TranslatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetTokenInterceptorService, multi: true
    },
     AppConfig,
  { provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [AppConfig], multi: true 
   }
   ,
   DatePipe,
   YearFormatterPipe,
   DateMonthFormatterPipe
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
